<template>
  <div class="cycle-tracker">
    <div class="cycle-bar">
      <div
        v-for="(day, index) in effectiveCycleLength"
        :key="index"
        :class="getDayClass(index)"
        class="cycle-day"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    startDate: {
      type: String,
      required: true
    },
    cycleLength: {
      type: Number,
      default: 28
    },
    periodLength: {
      type: Number,
      default: 4
    },
    predictedCycleLength: {
      type: Number,
      default: 27 // Predicción de duración del ciclo si no está finalizado
    }
  },
  computed: {
    effectiveCycleLength () {
      return this.cycleLength || this.predictedCycleLength
    },
    periodDays () {
      return Array.from({ length: this.periodLength }, (_, i) => i)
    },
    ovulationDays () {
      const ovulationDays = 6
      const ovulationBegin = 3 // De forma general dividiendo la duración del ciclo entre 2 nos situamos en mitad de la ovulación, como ésta dura seis días restando 3 tenemos el día que comienza
      const ovulationDay = Math.floor(this.effectiveCycleLength / 2)
      return Array.from({ length: ovulationDays }, (_, i) => ovulationDay - ovulationBegin + i)
    }
  },
  methods: {
    getDayClass (index) {
      if (this.periodDays.includes(index)) {
        return 'period-day'
      } else if (this.ovulationDays.includes(index)) {
        return this.cycleLength ? 'ovulation-day' : 'predicted-ovulation-day'
      } else {
        return 'normal-day'
      }
    }
  }
}
</script>

<style scoped>
.cycle-tracker {
  font-family: Arial, sans-serif;
  align-content: center;
  align-items: center;
  justify-content: center;
}
.cycle-bar {
  display: flex;
  margin-bottom: 10px;
}
.predicted-ovulation-day {
  background-color: orange
}
.cycle-day {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  margin: 0 2px;
}
.period-day {
  background-color: red
}
.ovulation-day {
  background-color: lightblue
}
.normal-day {
  background-color: rgb(213, 213, 213)
}
.cycle-info {
  margin-top: 10px
}
</style>



// WEBPACK FOOTER //
// src/components/views/clinicHistory/CycleChart.vue